module.exports = __webpack_public_path__ + "static/media/host-website-aws-s3-cloudfront.0153594f.md";